// Field schemas per document type: ordered list with label and kind
// kind: string | number | money | plate | vin | residentId | businessNo | date | year

export const FIELD_SCHEMAS = {
  '말소등록증': [
    { key: 'documentType', label: '문서 타입', kind: 'string' },
    { key: 'plateNumber', label: '차량등록번호', kind: 'plate' },
    { key: 'vin', label: '차대번호(VIN)', kind: 'vin' },
    { key: 'model', label: '차명(모델)', kind: 'string' },
    { key: 'modelYear', label: '연식(연도)', kind: 'year' },
    { key: 'mileage', label: '주행거리(km)', kind: 'number' },
    { key: 'deregistrationDate', label: '말소일자', kind: 'date' },
  ],
  '자동차등록증': [
    { key: 'documentType', label: '문서타입', kind: 'string' },
    { key: 'plateNumber', label: '차량등록번호', kind: 'plate' },
    { key: 'vin', label: '차대번호', kind: 'vin' },
    { key: 'model', label: '차명', kind: 'string' },
    { key: 'ownerName', label: '소유자명', kind: 'string' },
    { key: 'residentNumber', label: '생년월일\n(법인등록번호)', kind: 'residentId' },
    { key: 'address', label: '사용본거지', kind: 'string' },
    { key: 'mileage', label: '주행거리', kind: 'number' },
    { key: 'totalWeight', label: '총중량', kind: 'number' },
    { key: 'displacement', label: '배기량', kind: 'number' },
    { key: 'length', label: '길이', kind: 'number' },
    { key: 'width', label: '너비', kind: 'number' },
    { key: 'height', label: '높이', kind: 'number' },
    { key: 'cbm', label: 'CBM', kind: 'number' },
  ],
  '자동차등록원부': [
    { key: 'documentType', label: '문서 타입', kind: 'string' },
    { key: 'ownerName', label: '소유자', kind: 'string' },
    { key: 'residentNumber', label: '주민등록번호', kind: 'residentId' },
    { key: 'address', label: '주소', kind: 'string' },
    { key: 'plateNumber', label: '차량등록번호', kind: 'plate' },
    { key: 'vin', label: '차대번호(VIN)', kind: 'vin' },
    { key: 'model', label: '차명(모델)', kind: 'string' },
  ],
  '경락확인서': [
    { key: 'documentType', label: '문서 타입', kind: 'string' },
    { key: 'plateNumber', label: '차량등록번호', kind: 'plate' },
    { key: 'vin', label: '차대번호(VIN)', kind: 'vin' },
    { key: 'model', label: '차명(모델)', kind: 'string' },
    { key: 'ownerName', label: '소유자(매도자)', kind: 'string' },
    { key: 'residentNumber', label: '주민등록번호', kind: 'residentId' },
    { key: 'address', label: '주소', kind: 'string' },
    { key: 'modelYear', label: '연식(연도)', kind: 'year' },
    { key: 'mileage', label: '주행거리(km)', kind: 'number' },
    { key: 'displacement', label: '배기량(cc)', kind: 'number' },
    { key: 'totalWeight', label: '총중량(kg)', kind: 'number' },
    { key: 'length', label: '길이(mm)', kind: 'number' },
    { key: 'width', label: '너비(mm)', kind: 'number' },
    { key: 'height', label: '높이(mm)', kind: 'number' },
    { key: 'cbm', label: 'CBM(㎥)', kind: 'number' },
    { key: 'totalAmount', label: '매입금액(VAT포)', kind: 'money' },
    { key: 'auctionDate', label: '경락일자', kind: 'date' },
    { key: 'buyerName', label: '수출화주(매수자 상호)', kind: 'string' },
    { key: 'buyerBusinessNumber', label: '수출화주 사업자번호', kind: 'businessNo' },
  ],
  '자동차매매계약서': [
    { key: 'documentType', label: '문서 타입', kind: 'string' },
    { key: 'ownerName', label: '매도인', kind: 'string' },
    { key: 'residentNumber', label: '주민등록번호', kind: 'residentId' },
    { key: 'address', label: '주소', kind: 'string' },
    { key: 'plateNumber', label: '차량등록번호', kind: 'plate' },
    { key: 'vin', label: '차대번호(VIN)', kind: 'vin' },
    { key: 'model', label: '차명(모델)', kind: 'string' },
    { key: 'totalAmount', label: '계약금액(원)', kind: 'money' },
  ],
  '폐차증': [
    { key: 'documentType', label: '문서 타입', kind: 'string' },
    { key: 'ownerName', label: '소유자', kind: 'string' },
    { key: 'residentNumber', label: '주민등록번호', kind: 'residentId' },
    { key: 'address', label: '주소', kind: 'string' },
    { key: 'plateNumber', label: '차량등록번호', kind: 'plate' },
    { key: 'vin', label: '차대번호(VIN)', kind: 'vin' },
    { key: 'model', label: '차명(모델)', kind: 'string' },
    { key: 'modelYear', label: '연식(연도)', kind: 'year' },
    { key: 'deregistrationDate', label: '말소일자', kind: 'date' },
  ],
  '신분증': [
    { key: 'documentType', label: '문서 타입', kind: 'string' },
    { key: 'name', label: '성명', kind: 'string' },
    { key: 'residentNumber', label: '주민등록번호', kind: 'residentId' },
    { key: 'licenseNumber', label: '증번호', kind: 'string' },
    { key: 'issueDate', label: '발급일자', kind: 'date' },
    { key: 'address', label: '주소', kind: 'string' },
  ],
  '사업자등록증': [
    { key: 'documentType', label: '문서 타입', kind: 'string' },
    { key: 'businessName', label: '상호', kind: 'string' },
    { key: 'businessNumber', label: '사업자등록번호', kind: 'businessNo' },
    { key: 'ownerName', label: '대표자', kind: 'string' },
    { key: 'openDate', label: '개업연월일', kind: 'date' },
    { key: 'address', label: '사업장 소재지', kind: 'string' },
  ],
};

export const getSchemaForType = (docType) => {
  if (FIELD_SCHEMAS[docType]) return FIELD_SCHEMAS[docType];
  // fallback: common fields
  return [
    { key: 'documentType', label: '문서 타입', kind: 'string' },
    { key: 'ownerName', label: '소유자', kind: 'string' },
    { key: 'plateNumber', label: '차량등록번호', kind: 'plate' },
    { key: 'vin', label: '차대번호(VIN)', kind: 'vin' },
    { key: 'model', label: '차명(모델)', kind: 'string' },
  ];
};


